import type { ReactNode } from 'react'

interface DetailRowProps {
  label: string
  value: ReactNode
}

export function DetailRow({ label, value }: DetailRowProps) {
  return (
    <div>
      <div className="text-charcoal-50 text-sm">{label}</div>
      <div className="text-charcoal">{value}</div>
    </div>
  )
}
